// antd
import { Modal } from 'antd';

import './confirm.scss';
import { ReactNode } from 'react';
import i18n from '../../../utils/locales/config';

const { confirm } = Modal;


type ConfirmParams = {
 title: string
 icon?: ReactNode
 content: ReactNode
 onOk:() => void
 onCancel?: () => void
 cancelText?:string
 okText?:string
 className: string
 // antd's Modal.confirm defaults this to false, unlike a plain Modal --
 // left unset here so every other Confirm() call site (destructive "are
 // you sure?" prompts) keeps that default; InformationPopUp opts in
 // explicitly since an info card has no destructive action to protect.
 maskClosable?: boolean
}

// Not a React component — Confirm is invoked imperatively from event handlers, so it
// can't use useTranslation(). i18n.t() reads the singleton instance directly and is
// re-evaluated on every call (default params run per-invocation), so it stays correct
// across language switches without needing to be a hook.
const Confirm = ({ title, icon, content, onOk, onCancel, cancelText = i18n.t('general.cancel'), okText = i18n.t('general.ok'), className, maskClosable }:ConfirmParams) => {
    confirm({
        title,
        icon,
        content,
        onOk() {
            onOk();
        },
        closable: true,
        maskClosable,
        onCancel() {
            if (onCancel) {
                onCancel();
            }
        },
        cancelText,
        okText,
        className: 'confirmation' + ` ${className}`,
    });
};

export { Confirm };
